            
<template>  
  <div>    
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">
      <b-form  inline style="margin-bottom:15px" novalidate>
        <b-row>
                    <sw-inputs
                      inputTabla="info_orden"
                      inputCampo="fecha_recibido"
                      lg="12">
                    </sw-inputs>
        </b-row>
      </b-form>
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
          <sw-saveform
            nameBtn="Recibido"
            :invalid="invalid"
            @save="save"
            >
          </sw-saveform>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
export default 
{
  name: 'paciente',
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform        
  },
  props: {
  },
  created(){
    if(this.indexData!==false)
    {      
      this.updateDataForm({state: 'info_orden', data: this.dataGet[this.namePath].data[this.indexData].info_orden})
      this.updateDataForm({state: 'info_orden/fecha_recibido', data: this.fecha().fecha.minHoy})
      this.updateDataForm({state: 'info_orden/estado', data: 'recibido'})
    }    
  },
  async beforeDestroy()
  {
    await this.resetGlobal({state: 'indexData'})
    await this.resetDataForm()
  },
  methods: {
    save(event)
    {
      this.$emit('save',{save: false, ftn: 'recibidoOrdenFtn' })
    }
  }
}
</script>
<style>
</style>